export const FeeType = Object.freeze({
  RENDER: 'RENDER',
  DESKTOP: 'DESKTOP',
})

export const CdcTag = Object.freeze({
  MotherDisk: 1,
  SubMachine: 2,
})
